document.addEventListener('DOMContentLoaded',function(){
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!reduce){
    var els=document.querySelectorAll('.m-section, .m-hero, .product__media-wrapper, .product-info-wrapper, .content-grid, .press-slider');
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('m-inview');io.unobserve(e.target);}});},{threshold:.12});
    els.forEach(function(el){el.classList.add('m-animate');io.observe(el);});
    var imgs=document.querySelectorAll('.m-frame img, .product__media img, .m-band__img img, .m-steps__img img, .m-compare__img img, .m-card__img img');
    var io2=new IntersectionObserver(function(es){es.forEach(function(e){e.target.classList.toggle('m-imgin', e.isIntersecting);});},{threshold:.2});
    imgs.forEach(function(im){im.classList.add('m-imganim');io2.observe(im);});
  }
  var gal=document.querySelector('.product__media-gallery .swiper.images');
  document.querySelectorAll('.m-thumb').forEach(function(t){
    function go(){ if(gal&&gal.swiper){ gal.swiper.slideTo(parseInt(t.dataset.index,10)); }
      document.querySelectorAll('.m-thumb').forEach(function(x){x.classList.remove('m-thumb--on');});
      t.classList.add('m-thumb--on');
    }
    t.addEventListener('click',go);
    t.addEventListener('mouseenter',go);
  });
  // Rating under product title: fill from Okendo DOM if metafield missing; click scrolls to reviews
  var rt=document.querySelector('[data-m-rating]');
  if(rt){
    var cnt=rt.querySelector('.m-rating__count');
    var stars=rt.querySelector('.m-rating__stars');
    var tries=0;
    var iv=setInterval(function(){
      tries++;
      if(cnt.textContent.trim()){clearInterval(iv);return;}
      var n=null,avg=null;
      var ce=document.querySelector('.oke-sr-count-number');
      if(ce&&/\d/.test(ce.textContent))n=parseInt(ce.textContent.replace(/\D/g,''),10);
      var re=document.querySelector('.oke-sr-rating');
      if(re)avg=parseFloat(re.textContent);
      if(n===null){
        document.querySelectorAll('.okeReviews').forEach(function(w){
          if(n!==null)return;
          var m=w.textContent.match(/(\d+)\s+Review/i);
          if(m)n=parseInt(m[1],10);
        });
      }
      if(n!==null&&n>0){
        cnt.textContent=n+' Review'+(n===1?'':'s');
        if(avg&&avg>0&&avg<=5)stars.style.setProperty('--m-rate',(avg/5*100)+'%');
        clearInterval(iv);
      }else if(tries>12){
        rt.setAttribute('data-m-empty','');
        clearInterval(iv);
      }
    },800);
    // Brand-voice title on the reviews section once Okendo renders
    var rlTries=0;
    var rl=setInterval(function(){
      rlTries++;
      var h=document.querySelector('.oke-reviewCarousel-header-title');
      if(h){h.textContent='The reviews are in.';clearInterval(rl);}
      else if(rlTries>24){clearInterval(rl);}
    },500);
    rt.addEventListener('click',function(e){
      e.preventDefault();
      var ws=Array.prototype.slice.call(document.querySelectorAll('.okeReviews'));
      ws.sort(function(a,b){return b.getBoundingClientRect().height-a.getBoundingClientRect().height;});
      if(ws[0])ws[0].scrollIntoView({behavior:'smooth',block:'start'});
    });
  }
  // Hide redundant variant pickers that only have one option (e.g. single-color bundles)
  document.querySelectorAll('.product-info-wrapper fieldset.product-form__input--swatch').forEach(function(f){
    if(f.querySelectorAll('input').length<=1){
      var w=f.closest('variant-selects')||f.closest('variant-radios')||f;
      w.style.display='none';
    }
  });
  // Quote/testimonial sliders (swiper with dots): auto-advance every 3s, looping
  setTimeout(function(){
    document.querySelectorAll('.swiper').forEach(function(el){
      if(el.closest('.product__media-gallery'))return;
      var hasDots=el.querySelector('.swiper-pagination-bullet')||(el.parentElement&&el.parentElement.querySelector('.swiper-pagination-bullet'));
      if(!hasDots)return;
      setInterval(function(){
        if(document.hidden||!el.swiper)return;
        if(el.swiper.isEnd){el.swiper.slideTo(0);}else{el.swiper.slideNext();}
      },3000);
    });
  },2500);
  // Press cards: auto-advance carousel on mobile (3s) + tap arrow for next
  var pr=document.querySelector('.m-press__row');
  if(pr&&pr.children.length>1){
    var prIdx=0;
    var prGo=function(i){
      prIdx=(i+pr.children.length)%pr.children.length;
      var card=pr.children[prIdx];
      pr.scrollTo({left:card.offsetLeft-pr.offsetLeft,behavior:'smooth'});
    };
    var prArrow=document.querySelector('.m-press__next');
    if(prArrow)prArrow.addEventListener('click',function(){prGo(prIdx+1);});
    if(window.matchMedia('(max-width: 599px)').matches){
      setInterval(function(){
        if(document.hidden)return;
        prGo(prIdx+1);
      },3000);
    }
  }
  // Hide the Okendo floating "Reviews" tab (injected dynamically, so retry)
  var tabTries=0;
  var tabIv=setInterval(function(){
    tabTries++;
    document.querySelectorAll('[class*="oke"]').forEach(function(el){
      if(!/^\s*Reviews\s*$/.test(el.textContent||''))return;
      var w=el,target=null;
      while(w&&w!==document.body){ if(getComputedStyle(w).position==='fixed'){target=w;} w=w.parentElement; }
      (target||el).style.display='none';
    });
    if(tabTries>15)clearInterval(tabIv);
  },1000);
  // Best-review spotlight: pull the strongest review from the Okendo widget for this product
  var br=document.querySelector('[data-m-bestrev]');
  if(br){
    var brTries=0;
    var brIv=setInterval(function(){
      brTries++;
      var cards=Array.prototype.slice.call(document.querySelectorAll('.oke-reviewCarousel .hooper-slide:not(.is-clone):not(.hooper-clone) > div'));
      if(!cards.length){ if(brTries>24)clearInterval(brIv); return; }
      var neg=/pricey|price|expensive|overpriced|costly|only issue|issue is|not worth|too much|disappoint|unfortunately|however|downside|problem|gimmick|cheap|waste|returned|refund|wish it/i;
      var best=null,bestScore=0;
      cards.forEach(function(c){
        var fg=c.querySelector('.oke-stars-foreground');
        var five=fg&&/100/.test(fg.style.width||'');
        var body=c.querySelector('[class*="-body"]');
        var title=c.querySelector('[class*="-title"]');
        var text=body?body.textContent.trim():'';
        if(!text)return;
        var full=(title?title.textContent+' ':'')+text;
        if(neg.test(full))return; /* positive sentiment only */
        var score=(five?1000:0)+Math.min(text.length,300);
        if(score>bestScore){bestScore=score;best=c;}
      });
      if(!best){ if(brTries>24)clearInterval(brIv); return; }
      var t=best.querySelector('[class*="-title"]');
      var b=best.querySelector('[class*="-body"]');
      var n=best.querySelector('[class*="eviewer"]');
      var quote=(b?b.textContent.trim():'')||'';
      if(t&&t.textContent.trim()&&t.textContent.trim().toLowerCase()!==quote.toLowerCase().slice(0,t.textContent.trim().length)){
        quote=t.textContent.trim()+'. '+quote;
      }
      if(quote.length>220)quote=quote.slice(0,217).replace(/\s+\S*$/,'')+'…';
      if(!quote){ if(brTries>24)clearInterval(brIv); return; }
      br.querySelector('[data-m-bestrev-quote]').textContent=quote;
      var name=n?n.textContent.trim().split('\n')[0].replace(/Verified Buyer/i,'').trim():'A Mitts customer';
      br.querySelector('[data-m-bestrev-name]').textContent=name||'A Mitts customer';
      br.style.display='';
      clearInterval(brIv);
    },500);
  }
});
